<div class="map-time-bar-container">
  <button
    mat-icon-button
    class="center-icon-button map-time-bar-button"
    [matTooltip]="T_SCOPE + '.tooltips.play' | translate | lowercase"
    [disabled]="!hasAnyStep || playing"
    (click)="onPlay()"
  >
    <wlm-icon icon="play" class="map-custom-icon" [color]="iconColor" [size]="iconSize"></wlm-icon>
  </button>
  <span class="icon-separator">|</span>
  <button
    mat-icon-button
    class="center-icon-button map-time-bar-button"
    [matTooltip]="T_SCOPE + '.tooltips.stop' | translate | lowercase"
    [disabled]="!hasAnyStep || !playing"
    (click)="onStop()"
  >
    <wlm-icon icon="stop" class="map-custom-icon" [color]="iconColor" [size]="iconSize"></wlm-icon>
  </button>
  <span class="icon-separator">|</span>
  <button
    mat-icon-button
    class="center-icon-button map-time-bar-button"
    [matTooltip]="T_SCOPE + '.tooltips.filter' | translate | lowercase"
    [disabled]="!hasAnyStep || playing"
    [matMenuTriggerFor]="filterMenu"
  >
    <wlm-icon
      icon="calendar"
      class="map-custom-icon"
      [color]="iconColor"
      [size]="iconSize"
    ></wlm-icon>
  </button>
  <mat-menu #filterMenu="matMenu" class="time-bar-filter-menu" (click)="stopPropagation($event)">
    <div class="time-bar-filter-menu-container" (click)="stopPropagation($event)">
      <wlm-date-time-range
        *ngIf="filterDateRange"
        [maxDate]="maxDate"
        [dateRange]="filterDateRange"
        [displayHorizontal]="true"
        [valueDebounceTime]="filterDebounceTime"
        [enableApplyFilter]="true"
        (dateRangeErrors)="onDateRangeErrors($event)"
        (dateRangeChanged)="onDateRangeChanged($event)"
      ></wlm-date-time-range>
      <wlm-date-time-range-errors
        [validationErrors]="filterErrors"
        [maxDate]="maxDate"
      ></wlm-date-time-range-errors>
    </div>
  </mat-menu>
  <span class="icon-separator">|</span>
  <button
    mat-icon-button
    class="center-icon-button map-time-bar-button"
    [matTooltip]="T_SCOPE + '.tooltips.previous-step' | translate | lowercase"
    [disabled]="!hasAnyStep || mapDateRange.steps.length === 1 || playing"
    (click)="onPreviousStepClick()"
  >
    <wlm-icon
      icon="previous"
      class="map-custom-icon"
      [color]="iconColor"
      [size]="iconSize"
    ></wlm-icon>
  </button>
  <span class="current-step" *ngIf="currentStep">
    {{ currentStep | date }}
  </span>
  <span class="current-step" *ngIf="!currentStep">
    {{ T_SCOPE + '.no-step-selected' | translate }}</span
  >
  <button
    mat-icon-button
    class="center-icon-button map-time-bar-button"
    [matTooltip]="T_SCOPE + '.tooltips.next-step' | translate | lowercase"
    [disabled]="!hasAnyStep || playing"
    (click)="onNextStepClick()"
  >
    <wlm-icon icon="next" class="map-custom-icon" [color]="iconColor" [size]="iconSize"></wlm-icon>
  </button>

  <wlm-map-time-step-slider
    [mapDateRange]="mapDateRange"
    [currentStep]="currentStep"
    (stepChange)="onStepChange($event)"
  ></wlm-map-time-step-slider>
</div>
